import PercentFilters from "./percent";
import DateFilters from "./dates";
import TitleizeFilters from "./titleize";
import CurrencyFilters from "./currency";
import PhoneFilters from "./phone";
import TimeFilters from "./time";
import NumbersFilters from "./numbers";
import BooleanFilters from "./boolean";

const allFilters = [
  PercentFilters,
  DateFilters,
  TitleizeFilters,
  CurrencyFilters,
  PhoneFilters,
  TimeFilters,
  NumbersFilters,
  BooleanFilters,
];

export default {
  install(Vue) {
    allFilters.forEach((filters) => {
      Object.keys(filters).forEach((filterName) => {
        Vue.filter(filterName, filters[filterName]);
      });
    });
  },
};
